import React, { useEffect, useLayoutEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Home from '../pages/Home';
import Todas_las_experiencia from '../pages/Todas_las_experiencia';
import ExperienciaDetalle from '../pages/ExperienciaDetalles';
import Contacto from '../pages/Contacto';
import Quiene_Somos from '../pages/Quiene_Somos';
import Receñas from '../pages/Receñas';
import { registrarVisita } from '../analytics';
import { RUTAS, ALIAS_ES, idiomaDeUrl } from '../rutas';

// Manda una visita a Google Analytics cada vez que cambia la página.
// Espera un momento para que la página ya haya puesto su título.
function RastreoVisitas() {
  const { pathname } = useLocation();
  useEffect(() => {
    const id = setTimeout(() => registrarVisita(pathname), 500);
    return () => clearTimeout(id);
  }, [pathname]);
  return null;
}

// El idioma lo decide la URL: /en/... = inglés, el resto = español.
function SincronizarIdioma() {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  useLayoutEffect(() => {
    const lang = idiomaDeUrl(pathname);
    if (i18n.language !== lang) i18n.changeLanguage(lang);
  }, [pathname, i18n]);
  return null;
}

const PAGINAS = {
  home: <Home />,
  todas: <Todas_las_experiencia />,
  detalle: <ExperienciaDetalle />,
  nosotros: <Quiene_Somos />,
  resenas: <Receñas />,
  contacto: <Contacto />,
};

function Rutas() {
  return (
    <Router>
      <SincronizarIdioma />
      <RastreoVisitas />
      <Routes>
        {Object.entries(RUTAS).flatMap(([pagina, porIdioma]) => [
          <Route key={`${pagina}-es`} path={porIdioma.es} element={PAGINAS[pagina]} />,
          <Route key={`${pagina}-en`} path={porIdioma.en} element={PAGINAS[pagina]} />,
        ])}
        {ALIAS_ES.map((path) => (
          <Route key={path} path={path} element={<Home />} />
        ))}
      </Routes>
    </Router>
  );
}

export default Rutas;
